import * as _ from "lodash";
import createNumberMask from "text-mask-addons/dist/createNumberMask.js";
import { conformToMask } from "text-mask-core/dist/textMaskCore";

import { FormSchemaData, FormTextSchemaData } from "./form.interface";

// ConfiguraÃ§Ã£o das mascaras padrÃ£o: https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md and https://github.com/text-mask/text-mask/tree/master/addons
export const FormMasks = {
  money: {
    mask: createNumberMask({
      prefix: "R$ ",
      thousandsSeparatorSymbol: ".",
      decimalSymbol: ",",
      allowDecimal: true,
      allowNegative: true
    })
  },
  percentage: {
    mask: createNumberMask({
      prefix: "",
      thousandsSeparatorSymbol: ".",
      decimalSymbol: ",",
      allowNegative: false,
      allowDecimal: true
    })
  },
  salary: {
    mask: createNumberMask({
      prefix: "R$ ",
      thousandsSeparatorSymbol: ".",
      decimalSymbol: ",",
      allowDecimal: true
    })
  },
  phone: {
    mask: value => {
      const numbers = value.match(/\d/g);
      const length = numbers ? numbers.join("").length : 0;
      if (length > 10) {
        return [
          "(",
          /[0-9]/,
          /[0-9]/,
          ")",
          " ",
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          "-",
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          /[0-9]/
        ];
      } else {
        return [
          "(",
          /[0-9]/,
          /[0-9]/,
          ")",
          " ",
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          "-",
          /[0-9]/,
          /[0-9]/,
          /[0-9]/,
          /[0-9]/
        ];
      }
    },
    guide: false
  },
  cpf: {
    mask: [
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      ".",
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      ".",
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      "-",
      /[0-9]/,
      /[0-9]/
    ],
    guide: false
  },
  cnpj: {
    mask: [
      /[0-9]/,
      /[0-9]/,
      ".",
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      ".",
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      "/",
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      "-",
      /[0-9]/,
      /[0-9]/
    ],
    guide: false
  },
  rg: {
    mask: [
      /[0-9]/,
      /[0-9]/,
      ".",
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      ".",
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      "-",
      /[0-9]/
    ],
    guide: false
  },
  cep: {
    mask: [
      /[0-9]/,
      /[0-9]/,
      ".",
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      "-",
      /[0-9]/,
      /[0-9]/,
      /[0-9]/
    ],
    guide: false
  },
  date: {
    mask: [
      /[0-9]/,
      /[0-9]/,
      "/",
      /[0-9]/,
      /[0-9]/,
      "/",
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/
    ],
    guide: false
  },
  time: {
    mask: [/[0-9]/, /[0-9]/, ":", /[0-9]/, /[0-9]/],
    guide: false
  },
  creditcard: {
    mask: [
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      " ",
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      " ",
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      " ",
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/
    ],
    guide: false
  },
  creditcard_validity: {
    mask: [/[0-9]/, /[0-9]/, "/", /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
    guide: false
  }
};

function GetCurrentMask(value: string, info): (string | RegExp)[] {
  let rawValue = value.replace(/[^\d]/g, "");

  const rawLength = rawValue.length;
  const prefixMask = ["R", "$", " "];
  const decimalMask: (string | RegExp)[] = [",", /\d/, /\d/];
  const integerLength = rawLength > 3 ? rawLength - 2 : 1;
  const integerMask: (string | RegExp)[] = [];

  for (let x = 0; x < integerLength; x++) {
    const length = integerMask.filter((m): boolean => m !== ".").length;
    if (length && length % 3 === 0) integerMask.push(".");
    integerMask.push(/\d/);
  }

  return [...prefixMask, ...integerMask.reverse(), ...decimalMask];
}

export function GetMask(mask: any): any {
  if (_.isString(mask) && FormMasks[mask]) {
    return FormMasks[mask];
  } else {
    return mask;
  }
}

export function SetupSchemaMask(schema: FormSchemaData) {
  const mask_name = (<FormTextSchemaData>schema).mask;

  if (!mask_name || !schema.value) return;

  const mask = GetMask(mask_name);

  if (mask.mask) {
    let masks: Array<any> = [];

    if (_.isArray(mask.mask)) {
      masks = mask.mask;
    } else if (_.isFunction(mask.mask)) {
      masks = mask.mask(schema.value);
    }

    schema.value = (<any>conformToMask)(
      schema.value,
      masks.filter(item => item !== "[]"),
      { guide: false }
    ).conformedValue;
  }
}

export type FormSchemaMask =
  | "money"
  | "percentage"
  | "salary"
  | "phone"
  | "cpf"
  | "cnpj"
  | "rg"
  | "cep"
  | "date"
  | "time"
  | "creditcard"
  | "creditcard_validity";
